<div class="flex vcenter hcenter gap">
  <payee-icon [name]="'arrow-left-grey'" width="18px"></payee-icon>
  <span color="grey-dark">
    <ng-content></ng-content>
  </span>
</div>
